export default {
  unavailable: {
    title: 'Este serviço é operado pela Foodamigos',
    description:
      'A impressão de flyers e autocolantes é um serviço operado pela equipa Foodamigos e não está disponível para contas parceiras.',
  },
};
